export default __webpack_public_path__ + "static/privacy-policy-min-037a12387dfe5a6d40b010d5303b9a83.jpeg";